import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EntraService } from '../services/entra.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {
  private isCheckingAuth = false; // Prevent recursive checks

  constructor(
    private entraService: EntraService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Prevent recursive authentication checks
    if (this.isCheckingAuth) {
      return true;
    }

    this.isCheckingAuth = true;
    
    try {
      
      // Get the current authentication state WITHOUT triggering token acquisition
      const isLoggedIn = this.entraService.userIsLoggedIn();
      
      if (isLoggedIn) {
        // Use setTimeout to avoid navigation during guard execution
        setTimeout(() => {
          this.router.navigate(['/forms']);
          this.isCheckingAuth = false;
        }, 0);
        return false; // Prevent access to the current route
      }
      
      return true;
    } finally {
      // Reset flag after a short delay to prevent immediate re-triggering
      setTimeout(() => {
        this.isCheckingAuth = false;
      }, 100);
    }
  }
}